import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "not",
  "use": "not-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"not\"><path d=\"M2.25 9c0-1.456.462-2.806 1.249-3.91l9.41 9.41A6.719 6.719 0 0 1 9 15.75 6.758 6.758 0 0 1 2.25 9m13.5 0a6.716 6.716 0 0 1-1.25 3.91L5.09 3.5A6.72 6.72 0 0 1 9 2.25 6.758 6.758 0 0 1 15.75 9m-.387-6.364A8.937 8.937 0 0 0 9 0a8.94 8.94 0 0 0-6.364 2.636A8.936 8.936 0 0 0 0 9c0 2.404.935 4.664 2.636 6.364A8.94 8.94 0 0 0 9 18a8.937 8.937 0 0 0 6.363-2.636A8.937 8.937 0 0 0 18 9a8.937 8.937 0 0 0-2.637-6.364\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/not.svg
// module id = 1554
// module chunks = 0